import React, { useState, useEffect } from 'react'
import './LoadingScreen.css'
import Icone from '../../../../../assets/img/folha_ttivos.png'

interface AiLoadingOverlayProps {
  isLoading: boolean
}

export const AiLoadingOverlay: React.FC<AiLoadingOverlayProps> = ({ isLoading }) => {
  const [progress, setProgress] = useState(0)
  const [message, setMessage] = useState('Iniciando...')
  const [isVisible, setIsVisible] = useState(isLoading)

  useEffect(() => {
    if (isLoading) {
      setIsVisible(true)

      setMessage('Analisando imagem...')

      setTimeout(() => {
        setMessage('Extraindo dados...')
      }, 1000)

      setTimeout(() => {
        setMessage('Finalizando análise...')
      }, 2000);
    }else{
      setIsVisible(false)
    }
  }, [isLoading])

  if (!isVisible && !isLoading) return null

  return (
    <div
      className={`ai-loading-overlay ${!isLoading && progress === 100 ? 'fade-out-overlay' : ''}`}
    >
      <div className='ai-loading-content'>
        <img src={Icone} alt='Ícone' width='24' height='34' />

        <h3 className='ai-loading-text'>{message}</h3>

        <div className='ai-progress-track'>
          <div
            className='ai-progress-fill ai-shimmer-effect'
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    </div>
  )
}

export default AiLoadingOverlay
